import { GroupedPrefectures } from "../../../../shared/lib/types";

export const onCheckAllPrefecture = ({
  checked,
  onChange,
  value,
  groupedPrefectures,
}: {
  checked: boolean;
  onChange: (value: string[]) => void;
  value: string[];
  groupedPrefectures: GroupedPrefectures;
}) => {
  if (checked) {
    onChange(
      groupedPrefectures.flatMap(({ prefectures }) =>
        prefectures.map(({ id }) => id.toString()),
      ),
    );
  } else if (!checked && value.length === 47) {
    onChange([]);
  }
};
